import {
  ConfigurationNames,
  IConfigurationParams,
} from '../../../../graphql/configuration/models/configuration.models';
import { C2CMode } from '../configuration-settings.models';

export const getC2CMode = (configuration: IConfigurationParams[]): C2CMode => {
  const c2CMode = configuration.find((params) => params.name === ConfigurationNames.c2c);

  return c2CMode ? JSON.parse(c2CMode.configuration).mode : C2CMode.disabled;
};
